<template lang="html">
  <v-app>
    <loading />
    <v-main :class="[`white`]">
      <router-view />
      <alert v-model="showError" :type="errorType" :message="errorMessage" />
    </v-main>
  </v-app>
</template>
<script>
import '@/assets/sass/v2/variables.sass'
import Loading from '@/components/v2/Loading'
import Alert from '@/components/v2/Alert'
export default {
  components: {
    Loading,
    Alert
  },
  computed: {
    errorType() {
      return this.$store.getters.errorType === 200 ? 'success' : 'error'
    },
    errorMessage() {
      return this.$store.getters.errorMessage
    },
    'showError': {
      get() {
        return this.$store.getters.showError
      },
      set() {
        return (this.$store.state.show_error = false)
      }
    }
  },
  created() {
    if (!this.$isEmpty(this.$store.state.selected_store)) {
      this.title = this.$store.state.selected_store.name
      this.favicon = this.$store.state.selected_store.website_favicon
    }
    const colorTheme = this.$store.state.selected_store.setting.online_color
    const colorApp = colorTheme.split(',')
    if (colorApp) {
      this.$vuetify.theme.themes.light.primary = '#1FAD1F'
      this.$vuetify.theme.themes.dark.primary = '#1FAD1F'
    } else {
      this.$vuetify.theme.themes.light.primary = '#1FAD1F'
      this.$vuetify.theme.themes.dark.primary = '#1FAD1F'
    }
  },
  head: {
    title: function() {
      return {
        inner: this.title,
        separator: ' - ',
        complement: 'Pesan Online'
      }
    },
    link: function() {
      return [
        { rel: 'icon', type: 'image/png', sizes: '16x16', href: this.favicon },
        { rel: 'icon', type: 'image/png', sizes: '32x32', href: this.favicon },
        { rel: 'shorcut icon', type: 'image/png', sizes: '16x16', href: this.favicon },
        { rel: 'shorcut icon', type: 'image/png', sizes: '32x32', href: this.favicon }
      ]
    }
  }
}
</script>
<style>
  @import '../../assets/sass/v2.scss';
</style>
